<div class="profile-settings" [formGroup]="formModel.formGroup()">
  <h2><i class="icon-user pi pi-cog"></i>{{ "profileSettings" | translate }}</h2>
  <p class="subtitle">{{ "manageSettings" | translate }}</p>

  <!-- Personal Information -->
  <section class="card">
    <h3>
      <i class="icon-user pi pi-user"></i>
      {{ "personalInformation" | translate }}
    </h3>
    <p class="section-subtitle">{{ "updatePersonalInfo" | translate }}</p>

    <div class="form-grid">
      <div class="input-group">
        <label>{{ "firstName" | translate }}</label>
        <sxw-text-input formControlName="name"></sxw-text-input>
      </div>
      <div class="input-group">
        <label>{{ "lastName" | translate }}</label>
        <sxw-text-input formControlName="surname"></sxw-text-input>
      </div>
    </div>

    <div class="action-row">
      <sxw-button theme="mt-40px d-block submit-btn" label="{{ 'saveChanges' | translate }}" (onClick)="saveProfileChanges()">
        <i class="pi pi-save"></i>
      </sxw-button>
    </div>
  </section>

  <!-- Account Settings -->
  <section class="card">
    <h3>
      <i class="icon-lock pi pi-envelope"></i>
      {{ "accountSettings" | translate }}
    </h3>
    <p class="section-subtitle">{{ "manageAccountPreferences" | translate }}</p>

    <div class="credentials-box_text">
      <label>{{ "emailAddress" | translate }}</label>
      <div class="email-box">
        <input type="text" [value]="formModel.formGroup().get('email')?.value" readonly />
        <sxw-button theme="btn secondary " label="{{ 'updateEmailButton' | translate }}" (onClick)="onUpdateEmail()"> </sxw-button>
      </div>
      <small>{{ "emailNote" | translate }}</small>
    </div>
  </section>
  <!-- Security -->
  <section class="card">
    <h3>
      <i class="icon-lock pi pi-shield"></i>
      {{ "security" | translate }}
    </h3>

    <div class="security-box">
      <div class="password-field">
        <label>{{ "password" | translate }}</label>
        <p class="masked">********</p>
      </div>
      <sxw-button theme="btn secondary" label="{{ 'updatePassword' | translate }}" (onClick)="onResetPassword()"> </sxw-button>
    </div>
  </section>

  <!-- Danger Zone -->
  <section class="card danger-zone">
    <h3 class="danger-title"><i class="icon-lock pi pi-trash"></i> {{ "deleteAccount" | translate }}</h3>

    <p class="section-subtitle">{{ "deleteAccountWarning" | translate }}</p>
    <div class="action-row">
      <sxw-button theme="btn mt-40px d-block submit-btn red-background" label="{{ 'deleteAccount' | translate }}" (onClick)="onDeleteAccount()">
      </sxw-button>
    </div>
  </section>
</div>
